enum AdminFeedback {
  DEVICE_REMOVE_FAILED = "DEVICE_REMOVE_FAILED",
  DEVICE_REMOVED = "DEVICE_REMOVED",
  DEVICE_APROVE_FAILED = "DEVICE_APROVE_FAILED",
  DEVICE_APROVED = "DEVICE_APROVED",
  API_KEY_EDIT_FAILED = "API_KEY_EDIT_FAILED",
  API_KEY_EDITED = "API_KEY_EDITED",
  API_KEY_REMOVED = "API_KEY_REMOVED",
  API_KEY_REMOVE_FAILED = "API_KEY_REMOVE_FAILED",
  API_KEY_CREATED = "API_KEY_CREATED",
  API_KEY_CREATE_FAILED = "API_KEY_CREATE_FAILED",
  AUTHORIZATIONS_UPDATED = "AUTHORIZATIONS_UPDATED",
  AUTHORIZATIONS_UPDATE_FAILED = "AUTHORIZATIONS_UPDATE_FAILED",
  USER_LIST_FAILED = "USER_LIST_FAILED"
}

export default AdminFeedback;
